import type { Bounds, Camera, ObjectId, Size } from '@/types';
import { expand } from '@/core/geometry/bounds';
import { visibleWorldBounds } from '@/core/coordinates/coordinateSystem';
import type { SceneGraph } from '@/core/scene/sceneGraph';

/**
 * Returns the ids that should be mounted for the current camera. A world-space
 * margin keeps objects mounted slightly outside the viewport so panning does not
 * cause mount/unmount churn at the edges.
 */
export const cullVisible = (scene: SceneGraph, camera: Camera, viewport: Size, marginPx = 200): ObjectId[] => {
  const area: Bounds = expand(visibleWorldBounds(camera, viewport), marginPx / camera.zoom);
  return scene.queryBounds(area).filter((id) => scene.isInteractive(id));
};
